import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import BrandHeader from "../components/BrandHeader";
import { ordersApi } from "../lib/api";
import { BRAND, PRODUCT } from "../lib/constants";

const STEPS = [
  { t: "Payment confirmation", d: "Our team verifies your payment and sends a WhatsApp confirmation." },
  { t: "Prescription sent", d: "Your full prescription arrives on WhatsApp and your Sacred report lands in your inbox." },
  { t: "Crystal preparation", d: "Your stones are pulled from our inventory and cleansed under moonlight or Selenite." },
  { t: "Handcrafting", d: "Your bracelet is strung in the prescribed arrangement, sized to your wrist." },
  { t: "Dispatch", d: "Ships in 3 to 5 working days with tracking on your WhatsApp." },
];

export default function ThankYou() {
  const { id } = useParams();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    ordersApi.get(id).then(setOrder).catch(() => {});
  }, [id]);

  return (
    <div className="min-h-screen" data-testid="thank-you-page">
      <BrandHeader />
      <div className="max-w-3xl mx-auto px-5 md:px-10 py-16 text-center">
        <div className="ph-overline">Thank You</div>
        <h1 className="font-serif text-5xl md:text-6xl text-[#2C0A5E] mt-3">With gratitude, {order ? (order.fullName || "").trim().split(/\s+/)[0] : "Beautiful Soul"}.</h1>
        <p className="text-[#6B5E7E] mt-4 max-w-xl mx-auto">Your crystals have heard you. We will hand-make your bracelet with full presence and keep you updated every step.</p>

        {order && (
          <div className="ph-card p-6 mt-8 text-left max-w-md mx-auto" data-testid="order-summary">
            <div className="ph-overline">Order Summary</div>
            <div className="mt-3 space-y-1.5 text-sm text-[#2C0A5E]">
              <div className="flex justify-between"><span className="text-[#6B5E7E]">Order number</span><span className="font-medium">{order.orderNumber}</span></div>
              <div className="flex justify-between"><span className="text-[#6B5E7E]">Name</span><span>{order.fullName}</span></div>
              <div className="flex justify-between gap-3"><span className="text-[#6B5E7E]">Email</span><span className="truncate">{order.email}</span></div>
              <div className="flex justify-between"><span className="text-[#6B5E7E]">WhatsApp</span><span>{order.whatsapp}</span></div>
              <div className="flex justify-between"><span className="text-[#6B5E7E]">Total</span><span className="font-serif text-lg text-[#6A0DAD]">Rs {PRODUCT.price}</span></div>
            </div>
          </div>
        )}

        <div className="mt-10 text-left">
          <div className="ph-overline text-center">What happens next</div>
          <ol className="mt-6 space-y-4">
            {STEPS.map((s, i) => (
              <li key={i} className="ph-card p-5 flex gap-4" data-testid={`step-${i}`}>
                <div className="shrink-0 w-9 h-9 rounded-full bg-[#2C0A5E] text-[#D4A855] flex items-center justify-center font-serif">{i + 1}</div>
                <div>
                  <div className="font-serif text-lg text-[#2C0A5E]">{s.t}</div>
                  <div className="text-sm text-[#6B5E7E] mt-1">{s.d}</div>
                </div>
              </li>
            ))}
          </ol>
        </div>

        <div className="mt-10 text-sm text-[#6B5E7E]">
          Questions? WhatsApp <a className="text-[#6A0DAD] hover:underline" href={`https://wa.me/${BRAND.whatsapp}`}>{BRAND.whatsappDisplay}</a> or email <a className="text-[#6A0DAD] hover:underline" href={`mailto:${BRAND.email}`}>{BRAND.email}</a>.
        </div>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link to="/" className="ph-btn-ghost" data-testid="back-home">Back home</Link>
          <Link to="/prescription" className="ph-btn-primary" data-testid="new-prescription">Create another</Link>
        </div>
      </div>
    </div>
  );
}
